import { graphql, Environment } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';
import getRelayEnvironment from '../../../relayClientEnvironment';

import {
    completeAccountEmailMutation as MutationType,
    completeAccountEmailMutation$data,
    CompleteAccountEmailInput,
} from './__generated__/completeAccountEmailMutation.graphql';

const mutation = graphql`
    mutation completeAccountEmailMutation($input: CompleteAccountEmailInput!) {
        completeAccountEmail(input: $input) {
            message
        }
    }
`;

export function completeAccountEmailMutation({
    environment = getRelayEnvironment(),
    email,
}: CompleteAccountEmailInput & {
    environment?: Environment;
}): Promise<completeAccountEmailMutation$data> {
    return commitMutation<MutationType>(environment, {
        mutation,
        variables: {
            input: { email },
        },
    });
}
